import appStore from './AppStore';
import countryStore from './stores/CountryStore';
import risksStore from './stores/RisksStore';
import scoreEventStore from './components/scoringPage/ScoreEventStore';
import eventsFeedStore from './components/eventsFeed/EventsFeedStore';
import settingsStore from './stores/SettingsStore';
import customWeightStore from './stores/CustomWeightStore';
import insightsStore from './components/GQActivityPage/Insights/InsightsStore';
import annoStore from './stores/AnnotationsStore';
import UserStore from './stores/UserStore';
import chartStore from './components/GQChart/ChartStore';
import heatmapStore from './stores/HeatmapStore';
import insightsFeedStore from './components/GQActivityPage/activityPage/InsightsFeedStore';
import predictionsFeedStore from './components/GQActivityPage/activityPage/PredictionsFeedStore';

export interface IMobxRootState {
    chartStore: typeof chartStore;
    appStore: typeof appStore;
    countryStore: typeof countryStore;
    risksStore: typeof risksStore;
    scoreEventStore: typeof scoreEventStore;
    eventsFeedStore: typeof eventsFeedStore;
    settingsStore: typeof settingsStore;
    customWeightStore: typeof customWeightStore;
    insightsStore: typeof insightsStore;
    annoStore: typeof annoStore;
    UserStore: typeof UserStore;
    heatmapStore: typeof heatmapStore;
    insightsFeedStore: typeof insightsFeedStore;
    predictionsFeedStore: typeof predictionsFeedStore;
}

const rootState: IMobxRootState = {
    chartStore,
    appStore,
    scoreEventStore,
    eventsFeedStore,
    settingsStore,
    customWeightStore,
    countryStore,
    risksStore,
    insightsStore,
    annoStore,
    UserStore,
    heatmapStore,
    insightsFeedStore,
    predictionsFeedStore,
};

export function initRootStore() {
    Object.values(rootState).forEach(store => {
        if (typeof store.toInitialState === 'function') {
            store.toInitialState();
        }
    });
}

(window as any).rootStore = rootState;

export default rootState;
